type InboxSupportFeedbackEventsBaseArgs = {
  threadId: string
  helpCenterSessionId: string
}

type InboxSupportFeedbackRequestClickedEventsArgs = InboxSupportFeedbackEventsBaseArgs & {
  rating: number
}

type InboxSupportFeedbackFormSubmittedEventsArgs = InboxSupportFeedbackEventsBaseArgs & {
  rating: number
  comment?: string
  issueResolved?: boolean
}

export const chatbotFeedbackV2RequestViewed = (args: InboxSupportFeedbackEventsBaseArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'automated_support_feedback.chatbot_feedback_v2_request_viewed',
    extra,
  }
}

export const autoreplyFeedbackV2RequestViewed = (args: InboxSupportFeedbackEventsBaseArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'automated_support_feedback.auto_reply_feedback_v2_request_viewed',
    extra,
  }
}

export const chatbotFeedbackV2RequestClicked = (
  args: InboxSupportFeedbackRequestClickedEventsArgs,
) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
    rating: args.rating,
  }

  return {
    event: 'automated_support_feedback.chatbot_feedback_v2_request_clicked',
    extra,
  }
}

export const autoreplyFeedbackV2RequestClicked = (
  args: InboxSupportFeedbackRequestClickedEventsArgs,
) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
    rating: args.rating,
  }

  return {
    event: 'automated_support_feedback.auto_reply_feedback_v2_request_clicked',
    extra,
  }
}

export const chatbotFeedbackV2FormSubmitted = (
  args: InboxSupportFeedbackFormSubmittedEventsArgs,
) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
    rating: args.rating,
    comment: args.comment,
    issue_resolved: args.issueResolved,
  }

  return {
    event: 'automated_support_feedback.chatbot_feedback_v2_form_submitted',
    extra,
  }
}

export const autoReplyFeedbackV2FormSubmitted = (
  args: InboxSupportFeedbackFormSubmittedEventsArgs,
) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
    rating: args.rating,
    comment: args.comment,
    issue_resolved: args.issueResolved,
  }

  return {
    event: 'automated_support_feedback.auto_reply_feedback_v2_form_submitted',
    extra,
  }
}

export const chatbotFeedbackV2FormViewed = (args: InboxSupportFeedbackEventsBaseArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'automated_support_feedback.chatbot_feedback_v2_form_viewed',
    extra,
  }
}

export const autoReplyFeedbackV2FormViewed = (args: InboxSupportFeedbackEventsBaseArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'automated_support_feedback.auto_reply_feedback_v2_form_viewed',
    extra,
  }
}
